import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import DealsTable from "@/components/DealsTable";

export default function Applications() {
  const { user } = useAuth();

  return (
    <div className="max-w-[1600px] space-y-14" data-testid="applications-page">
      <header className="flex items-end justify-between flex-wrap gap-6">
        <div>
          <div className="small-caps text-slate-500">Your files</div>
          <h1 className="mt-6 font-semibold text-[72px] leading-[0.9] tracking-tight text-[#1F2937]">
            The <span className="italic">files.</span>
          </h1>
        </div>
        {(user?.role === "borrower" || user?.role === "broker") && (
          <Link to="/app/applications/new" className="group inline-flex items-center gap-4" data-testid="apps-new-btn">
            <span className="h-[1px] w-16 bg-slate-800 transition-all group-hover:w-24" />
            <span className="small-caps text-[#1F2937]">New Application</span>
          </Link>
        )}
      </header>

      <DealsTable title="Every file" subtitle="Full workbook" />
    </div>
  );
}
